module.exports = "/greycat-playground/03f42690a8619d1ddec5d03108c8c835.wasm";